import React from "react";
import ReactDOM from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "./assets/css/demo.css";
import "./assets/css/font-awesome.min.css";
import 'react-toastify/dist/ReactToastify.css';

import { initConfig } from './config';
import App from './App';

// Initialize runtime config before rendering
initConfig().then(() => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(<App />);
});
